// module containing static data
// dynamic data is in jsx page
const OrigamiContent = {
    origami: [
        {
            name: <div>
                <p><b>Octopus</b></p>
            </div>,
            image1: <div>
                <img className="img-origami" src="" alt="origami-octopus" />
            </div>,
            image2: <div>
            </div>,
            describe: <div>
                <p>The octopus isn't something you might have thought to make out of paper, because paper is rigid and octopi are charactaristically flexible, but that just makes designing the model all the more interesting! Essentially, an octopus can be made out of a paper square by dividing the square into quadrants and using a technique called box-pleating for each quadrant, where one center box and and its diagonal opposite are halved, so that the arms that end in the corners are equal in length to those that end at the midpoint of the paper's edge, and finally using the remaining two center boxes to make the eyes.</p>
            </div>
        },
        {
            name: <div>
                <p><b>Seahorse</b></p>
            </div>,
            image1: <div>
                <img className="img-origami" src="" alt="origami-seahorse" />
            </div>,
            image2: <div>
            </div>,
            describe: <div>
                <p>The seahorse model is one that is surprisingly simple due to the bilateral symmetry of seahorse morphology. It begins with the triangle base. What is nice about this model is that the basic shape is so simple to create that much of the character in each instance of the model comes from subtler methods like shaping the head, pleating the fins to give them ridges, and angling the tail to give the seahorse some personality.</p>
            </div>
        },
    ],
};
export { OrigamiContent };